import { createAction } from '@reduxjs/toolkit';

export const clearStore = createAction('CLEAR_STORE');
